// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2IzlR","footer":"ModalInfo_footer__1GJcy"};